<template>
  <div
    class="modal-dialog"
    :class="[
      typeof size === 'string' && `modal-${size}`,
      { 'modal-dialog-centered': center },
    ]"
    :style="[
      typeof size === 'number' && {
        maxWidth: `${size}px`,
      },
    ]"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
type Props = {
  center?: boolean;
  size?: "sm" | "md" | "lg" | number;
};

withDefaults(defineProps<Props>(), {
  size: "md",
});
</script>
